import React from 'react';
import { PlusButton, ShareView } from 'components';
import { useNodeDispatch } from 'context';
import { useQuery } from '@apollo/react-hooks';
import styles from '../../FeedListItem.module.scss';
import { ShareViewPlaceholder } from '../ShareView/ShareViewPlaceholder';
import { ShareButtonQuery } from 'services/apollo/queries/nodeQueries';
interface ShareButtonProps {
  nodeId: string;
  shareTargets: any;
}

export const ShareButton: React.FC<ShareButtonProps> = ({ nodeId, shareTargets }) => {
  const nodeDispatch = useNodeDispatch();

  const { data } = useQuery(ShareButtonQuery, {
    fetchPolicy: 'cache-first',
  });

  return (
    <div
      onClick={() => {
        nodeDispatch({ type: 'OPEN_NODE', payload: nodeId });
      }}
    >
      <PlusButton
        size="S"
        className={styles.shareButton}
        activeClassName={styles.active}
        id={`shareButton-${nodeId}`}
        type={'sharing'}
        content={
          !nodeId.includes(shareTargets?.nodeId) ? (
            <>
              <ShareViewPlaceholder />
            </>
          ) : (
            <ShareView
              nodeId={nodeId}
              groupTargets={shareTargets?.groupTargets || undefined}
              orgPeopleTargets={shareTargets?.orgPeopleTargets || undefined}
              otherPeopleTargets={shareTargets?.otherPeopleTargets || undefined}
              organizationType={data?.me?.organization?.type || undefined}
              organizationName={data?.me?.organization?.name || undefined}
            />
          )
        }
      />
    </div>
  );
};
